import {
  newTaskConverter,
  taskConverter as _taskConverter,
} from '@griply/services';
import { Task } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const taskConverter =
  _taskConverter as unknown as FirestoreDataConverter<Task>;
export { newTaskConverter };
